import { render, staticRenderFns } from "./careers.vue?vue&type=template&id=6b29fbf5"
import script from "./careers.vue?vue&type=script&lang=js"
export * from "./careers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./locale/careers-en.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fpages%2Fdiscover-dfm%2Fcareers.vue&locale=en&external"
if (typeof block0 === 'function') block0(component)
import block1 from "./locale/careers-ar.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fpages%2Fdiscover-dfm%2Fcareers.vue&locale=ar&external"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHero: require('/vercel/path0/components/PageHero.vue').default,CareersForm: require('/vercel/path0/components/forms/CareersForm.vue').default,PageIntroBlock: require('/vercel/path0/components/PageIntroBlock.vue').default})
